// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3hB_u","rightAdornment":"Header_rightAdornment__S9XYt"};